import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

interface SummaryStatCard {
  label?: string;
  value?: string | number;
  icon?: string;
  iconBg?: string;
  iconColor?: string;
}

@Component({
  selector: 'app-summary-stat-cards',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './summary-stat-cards.component.html',
  styleUrl: './summary-stat-cards.component.scss',
})
export class SummaryStatCardsComponent {
  @Input() data: any;

  get cards(): SummaryStatCard[] {
    return Array.isArray(this.data?.cards) ? this.data.cards : [];
  }

  get columns(): string {
    const configured = Number(this.data?.columns);
    const count = Number.isFinite(configured) && configured > 0 ? configured : this.cards.length || 3;
    return `repeat(${Math.min(count, 4)}, minmax(220px, 1fr))`;
  }

  get gap(): string {
    return this.normalizeCssSize(this.data?.gap, '28px');
  }

  get cardMinHeight(): string {
    return this.normalizeCssSize(this.data?.cardMinHeight, '88px');
  }

  get maxWidth(): string {
    return this.normalizeCssSize(this.data?.maxWidth, '980px');
  }

  get variant(): string {
    return String(this.data?.variant || '').trim();
  }

  getCardStyle(card: SummaryStatCard): Record<string, string> {
    return {
      '--summary-icon-bg': String(card.iconBg || this.data?.iconBg || '#2f8df4'),
      '--summary-icon-color': String(card.iconColor || this.data?.iconColor || '#ffffff'),
      'min-height': this.cardMinHeight,
    };
  }

  private normalizeCssSize(value: unknown, fallback: string): string {
    if (typeof value === 'number' && Number.isFinite(value)) {
      return `${value}px`;
    }
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
    return fallback;
  }
}
